// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
  background: #f8fafc;
  text-align: left;
}
.home-page, .home-page * { box-sizing: border-box; }

.home-workspace {
  display: flex;
  position: relative;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}
.home-map { flex: 1 1 auto; min-width: 0; min-height: 0; position: relative; overflow: hidden; }
.home-map .map-container { width: 100%; height: 100%; min-height: 0; }
.home-properties {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  width: min(100%, clamp(440px, 44vw, 680px));
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #fff;
  border-left: 1px solid #e5e7eb;
  transform: translateX(0);
  transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1);
}
.home-workspace--list-collapsed .home-properties {
  transform: translateX(100%);
  pointer-events: none;
}
.home-workspace--list-collapsed .search-expansion-notice {
  right: 14px;
}
.home-properties__sheet {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
}
.home-properties__heading {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  min-height: 36px;
  padding: 8px 12px;
  border-bottom: 1px solid #f0e7e0;
}
.home-properties__heading h1 {
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 700;
  color: #334155;
}
.home-properties__heading-actions { display: flex; align-items: center; gap: 8px; min-width: 0; }
.home-properties__heading-actions > span { font-size: 11px; color: #78716c; white-space: nowrap; }
.home-properties--refreshing .property-list {
  opacity: 0.62;
  pointer-events: none;
}
.home-properties--refreshing .home-properties__heading::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 38%;
  height: 2px;
  border-radius: 2px;
  background: #fa7317;
  animation: home-properties-refresh 0.9s ease-in-out infinite;
}
@keyframes home-properties-refresh {
  from { transform: translateX(-120%); }
  to { transform: translateX(280%); }
}
.home-properties__collapse {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 0 8px 0 10px;
  border: 1px solid rgba(250, 115, 23, 0.2);
  border-radius: 8px;
  background: #fff;
  color: #c2410c;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.home-properties__collapse i { font-size: 12px; }
.home-properties__collapse:hover { background: #fff7ed; }
.home-properties-reopen {
  position: absolute;
  z-index: 4;
  top: 50%;
  right: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px 0 12px;
  border: 1px solid rgba(250, 115, 23, 0.22);
  border-right: 0;
  border-radius: 12px 0 0 12px;
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 247, 237, 0.96) 100%);
  box-shadow: -8px 8px 24px rgba(15, 23, 42, 0.12);
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transform: translate(100%, -50%);
  opacity: 0;
  pointer-events: none;
  transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.42s ease;
}
.home-workspace--list-collapsed .home-properties-reopen {
  transform: translate(0, -50%);
  opacity: 1;
  pointer-events: auto;
}
.home-properties-reopen strong {
  min-width: 1.25rem;
  color: #c2410c;
  font-size: 13px;
  text-align: center;
}
.home-properties-reopen i { color: #fa7317; font-size: 14px; }
.home-properties__content { flex: 1 1; min-height: 0; overflow-y: auto; overscroll-behavior: contain; }
.home-properties__content:has(.property-list-empty) { display: flex; flex-direction: column; }
.home-properties .property-list-empty { flex: 1 1; width: 100%; min-height: 100%; }
.home-properties .property-list-container { height: auto; min-height: 100%; }
.home-properties .property-list-toolbar { position: static; }
.home-properties .property-list-scroll { overflow: visible; flex: none; }
.home-properties .property-list { height: auto; width: 100%; margin: 0; }
.home-properties .error-message { padding: 24px 16px; font-size: 14px; }
.home-zone-error { margin: 8px 12px; padding: 10px; color: #991b1b; background: #fff1f2; border-radius: 8px; font-size: 12px; }

.home-map > .map-container { z-index: 0; }
.search-expansion-notice {
  position: absolute;
  top: 14px;
  right: calc(min(100%, clamp(440px, 44vw, 680px)) + 14px);
  z-index: 3;
  width: min(340px, calc(100% - 28px));
  max-height: calc(100% - 28px);
  overflow-y: auto;
  margin: 0;
  box-shadow: 0 5px 18px rgba(72, 46, 27, 0.12);
  padding: 11px 32px 11px 12px;
  border: 1px solid #f6d4b7;
  border-left: 3px solid #efaa77;
  border-radius: 9px;
  background: #fff8f1;
  color: #854422;
  font-size: 12px;
}
.search-expansion-notice strong { display: flex; align-items: center; gap: 7px; font-weight: 700; }
.search-expansion-notice p { margin: 6px 0 0; line-height: 1.4; }
.search-expansion-notice button { font: inherit; cursor: pointer; }
.search-expansion-notice__close { position: absolute; top: 5px; right: 5px; width: 26px; height: 26px; border: 0; background: transparent; color: #9a6c50; }
.search-expansion-notice__actions { display: flex; flex-wrap: wrap; gap: 7px; margin-top: 9px; }
.search-expansion-notice__actions button { border: 1px solid #efc39f; border-radius: 6px; padding: 6px 10px; color: #854422; background: #fff; font-weight: 600; }
.search-expansion-notice__actions button:first-child { background: #f9dfc8; border-color: #efbf97; color: #783b1c; }
.search-expansion-notice__actions button:hover { background: #ffecd9; }
.search-expansion-notice button:focus-visible { outline: 2px solid #c8753c; outline-offset: 2px; }

@media (max-width: 800px) {
  .home-workspace { flex-direction: column; }
  .home-map { flex: 1 1 auto; }
  .home-properties {
    top: auto;
    left: 0;
    width: 100%;
    height: calc(100% - var(--home-map-peek, clamp(160px, 28dvh, 270px)));
    border-left: 0;
    border-top: 1px solid #e5e7eb;
    transform: translateY(0);
  }
  .home-workspace--list-collapsed .home-properties { transform: translateY(100%); }
  .home-properties-reopen {
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    justify-content: center;
    border-right: 0;
    border-bottom: 0;
    border-radius: 12px 12px 0 0;
    transform: translateY(100%);
  }
  .home-workspace--list-collapsed .home-properties-reopen { transform: translateY(0); }
  .home-properties__heading { min-height: 32px; padding: 7px 10px; }
  .home-properties__heading h1 { font-size: 12.5px; }
  .search-expansion-notice,
  .home-workspace--list-collapsed .search-expansion-notice {
    top: 10px;
    right: 10px;
    width: min(310px, calc(100% - 20px));
    max-height: calc(100% - 20px);
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 11px;
  }
  .home-workspace:not(.home-workspace--list-collapsed) .search-expansion-notice {
    right: 10px;
    max-height: calc(clamp(160px, 28dvh, 270px) - 20px);
  }
}
@media (max-height: 650px) and (max-width: 800px) {
  .home-properties { height: calc(100% - var(--home-map-peek, 130px)); }
  .home-properties__heading { min-height: 30px; padding: 6px 12px; }
}
@media (prefers-reduced-motion: reduce) {
  .home-properties,
  .home-properties-reopen {
    transition: none;
  }
  .home-properties--refreshing .home-properties__heading::after {
    animation: none;
    width: 100%;
    transform: none;
  }
}

@media (max-width: 800px) {
  .home-workspace--property-selected { --home-map-peek: clamp(230px, 36dvh, 300px); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,2BAA2B,sBAAsB,EAAE;;AAEnD;EACE,aAAa;EACb,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA,YAAY,cAAc,EAAE,YAAY,EAAE,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC/F,2BAA2B,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE;AACrE;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,0DAA0D;AAC5D;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,oCAAoC,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAChG,2CAA2C,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACjG;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4DAA4D;AAC9D;AACA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,2BAA2B,EAAE;AACpC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,+BAA+B,eAAe,EAAE;AAChD,mCAAmC,mBAAmB,EAAE;AACxD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,eAAe;EACf,4BAA4B;EAC5B,iGAAiG;EACjG,gDAAgD;EAChD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,oBAAoB;EACpB,8EAA8E;AAChF;AACA;EACE,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D,4BAA4B,SAAO,EAAE,aAAa,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACpG,sDAAsD,aAAa,EAAE,sBAAsB,EAAE;AAC7F,wCAAwC,SAAO,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAChF,4CAA4C,YAAY,EAAE,gBAAgB,EAAE;AAC5E,0CAA0C,gBAAgB,EAAE;AAC5D,yCAAyC,iBAAiB,EAAE,UAAU,EAAE;AACxE,kCAAkC,YAAY,EAAE,WAAW,EAAE,SAAS,EAAE;AACxE,kCAAkC,kBAAkB,EAAE,eAAe,EAAE;AACvE,mBAAmB,gBAAgB,EAAE,aAAa,EAAE,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAE9H,6BAA6B,UAAU,EAAE;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,wDAAwD;EACxD,UAAU;EACV,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,6CAA6C;EAC7C,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA,kCAAkC,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAClG,6BAA6B,eAAe,EAAE,gBAAgB,EAAE;AAChE,kCAAkC,aAAa,EAAE,eAAe,EAAE;AAClE,kCAAkC,kBAAkB,EAAE,QAAQ,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAC3J,oCAAoC,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC/F,2CAA2C,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACjK,uDAAuD,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACnH,iDAAiD,mBAAmB,EAAE;AACtE,gDAAgD,0BAA0B,EAAE,mBAAmB,EAAE;;AAEjG;EACE,kBAAkB,sBAAsB,EAAE;EAC1C,YAAY,cAAc,EAAE;EAC5B;IACE,SAAS;IACT,OAAO;IACP,WAAW;IACX,qEAAqE;IACrE,cAAc;IACd,6BAA6B;IAC7B,wBAAwB;EAC1B;EACA,mDAAmD,2BAA2B,EAAE;EAChF;IACE,SAAS;IACT,QAAQ;IACR,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA,0DAA0D,wBAAwB,EAAE;EACpF,4BAA4B,gBAAgB,EAAE,iBAAiB,EAAE;EACjE,+BAA+B,iBAAiB,EAAE;EAClD;;IAEE,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,WAAW;IACX,mDAAmD;EACrD;AACF;AACA;EACE,mBAAmB,gDAAgD,EAAE;EACrE,4BAA4B,gBAAgB,EAAE,iBAAiB,EAAE;AACnE;AACA;EACE;;IAEE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,qCAAqC,2CAA2C,EAAE;AACpF","sourcesContent":[".home-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh;\n  min-height: 0;\n  overflow: hidden;\n  background: #f8fafc;\n  text-align: left;\n}\n.home-page, .home-page * { box-sizing: border-box; }\n\n.home-workspace {\n  display: flex;\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n.home-map { flex: 1 1 auto; min-width: 0; min-height: 0; position: relative; overflow: hidden; }\n.home-map .map-container { width: 100%; height: 100%; min-height: 0; }\n.home-properties {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  width: min(100%, clamp(440px, 44vw, 680px));\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  background: #fff;\n  border-left: 1px solid #e5e7eb;\n  transform: translateX(0);\n  transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1);\n}\n.home-workspace--list-collapsed .home-properties {\n  transform: translateX(100%);\n  pointer-events: none;\n}\n.home-workspace--list-collapsed .search-expansion-notice {\n  right: 14px;\n}\n.home-properties__sheet {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n.home-properties__heading {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-shrink: 0;\n  min-height: 36px;\n  padding: 8px 12px;\n  border-bottom: 1px solid #f0e7e0;\n}\n.home-properties__heading h1 {\n  margin: 0;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 700;\n  color: #334155;\n}\n.home-properties__heading-actions { display: flex; align-items: center; gap: 8px; min-width: 0; }\n.home-properties__heading-actions > span { font-size: 11px; color: #78716c; white-space: nowrap; }\n.home-properties--refreshing .property-list {\n  opacity: 0.62;\n  pointer-events: none;\n}\n.home-properties--refreshing .home-properties__heading::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 38%;\n  height: 2px;\n  border-radius: 2px;\n  background: #fa7317;\n  animation: home-properties-refresh 0.9s ease-in-out infinite;\n}\n@keyframes home-properties-refresh {\n  from { transform: translateX(-120%); }\n  to { transform: translateX(280%); }\n}\n.home-properties__collapse {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 32px;\n  padding: 0 8px 0 10px;\n  border: 1px solid rgba(250, 115, 23, 0.2);\n  border-radius: 8px;\n  background: #fff;\n  color: #c2410c;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.home-properties__collapse i { font-size: 12px; }\n.home-properties__collapse:hover { background: #fff7ed; }\n.home-properties-reopen {\n  position: absolute;\n  z-index: 4;\n  top: 50%;\n  right: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 16px 0 12px;\n  border: 1px solid rgba(250, 115, 23, 0.22);\n  border-right: 0;\n  border-radius: 12px 0 0 12px;\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 247, 237, 0.96) 100%);\n  box-shadow: -8px 8px 24px rgba(15, 23, 42, 0.12);\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  transform: translate(100%, -50%);\n  opacity: 0;\n  pointer-events: none;\n  transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.42s ease;\n}\n.home-workspace--list-collapsed .home-properties-reopen {\n  transform: translate(0, -50%);\n  opacity: 1;\n  pointer-events: auto;\n}\n.home-properties-reopen strong {\n  min-width: 1.25rem;\n  color: #c2410c;\n  font-size: 13px;\n  text-align: center;\n}\n.home-properties-reopen i { color: #fa7317; font-size: 14px; }\n.home-properties__content { flex: 1; min-height: 0; overflow-y: auto; overscroll-behavior: contain; }\n.home-properties__content:has(.property-list-empty) { display: flex; flex-direction: column; }\n.home-properties .property-list-empty { flex: 1; width: 100%; min-height: 100%; }\n.home-properties .property-list-container { height: auto; min-height: 100%; }\n.home-properties .property-list-toolbar { position: static; }\n.home-properties .property-list-scroll { overflow: visible; flex: none; }\n.home-properties .property-list { height: auto; width: 100%; margin: 0; }\n.home-properties .error-message { padding: 24px 16px; font-size: 14px; }\n.home-zone-error { margin: 8px 12px; padding: 10px; color: #991b1b; background: #fff1f2; border-radius: 8px; font-size: 12px; }\n\n.home-map > .map-container { z-index: 0; }\n.search-expansion-notice {\n  position: absolute;\n  top: 14px;\n  right: calc(min(100%, clamp(440px, 44vw, 680px)) + 14px);\n  z-index: 3;\n  width: min(340px, calc(100% - 28px));\n  max-height: calc(100% - 28px);\n  overflow-y: auto;\n  margin: 0;\n  box-shadow: 0 5px 18px rgba(72, 46, 27, 0.12);\n  padding: 11px 32px 11px 12px;\n  border: 1px solid #f6d4b7;\n  border-left: 3px solid #efaa77;\n  border-radius: 9px;\n  background: #fff8f1;\n  color: #854422;\n  font-size: 12px;\n}\n.search-expansion-notice strong { display: flex; align-items: center; gap: 7px; font-weight: 700; }\n.search-expansion-notice p { margin: 6px 0 0; line-height: 1.4; }\n.search-expansion-notice button { font: inherit; cursor: pointer; }\n.search-expansion-notice__close { position: absolute; top: 5px; right: 5px; width: 26px; height: 26px; border: 0; background: transparent; color: #9a6c50; }\n.search-expansion-notice__actions { display: flex; flex-wrap: wrap; gap: 7px; margin-top: 9px; }\n.search-expansion-notice__actions button { border: 1px solid #efc39f; border-radius: 6px; padding: 6px 10px; color: #854422; background: #fff; font-weight: 600; }\n.search-expansion-notice__actions button:first-child { background: #f9dfc8; border-color: #efbf97; color: #783b1c; }\n.search-expansion-notice__actions button:hover { background: #ffecd9; }\n.search-expansion-notice button:focus-visible { outline: 2px solid #c8753c; outline-offset: 2px; }\n\n@media (max-width: 800px) {\n  .home-workspace { flex-direction: column; }\n  .home-map { flex: 1 1 auto; }\n  .home-properties {\n    top: auto;\n    left: 0;\n    width: 100%;\n    height: calc(100% - var(--home-map-peek, clamp(160px, 28dvh, 270px)));\n    border-left: 0;\n    border-top: 1px solid #e5e7eb;\n    transform: translateY(0);\n  }\n  .home-workspace--list-collapsed .home-properties { transform: translateY(100%); }\n  .home-properties-reopen {\n    top: auto;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    justify-content: center;\n    border-right: 0;\n    border-bottom: 0;\n    border-radius: 12px 12px 0 0;\n    transform: translateY(100%);\n  }\n  .home-workspace--list-collapsed .home-properties-reopen { transform: translateY(0); }\n  .home-properties__heading { min-height: 32px; padding: 7px 10px; }\n  .home-properties__heading h1 { font-size: 12.5px; }\n  .search-expansion-notice,\n  .home-workspace--list-collapsed .search-expansion-notice {\n    top: 10px;\n    right: 10px;\n    width: min(310px, calc(100% - 20px));\n    max-height: calc(100% - 20px);\n    padding-top: 8px;\n    padding-bottom: 8px;\n    font-size: 11px;\n  }\n  .home-workspace:not(.home-workspace--list-collapsed) .search-expansion-notice {\n    right: 10px;\n    max-height: calc(clamp(160px, 28dvh, 270px) - 20px);\n  }\n}\n@media (max-height: 650px) and (max-width: 800px) {\n  .home-properties { height: calc(100% - var(--home-map-peek, 130px)); }\n  .home-properties__heading { min-height: 30px; padding: 6px 12px; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .home-properties,\n  .home-properties-reopen {\n    transition: none;\n  }\n  .home-properties--refreshing .home-properties__heading::after {\n    animation: none;\n    width: 100%;\n    transform: none;\n  }\n}\n\n@media (max-width: 800px) {\n  .home-workspace--property-selected { --home-map-peek: clamp(230px, 36dvh, 300px); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
